import { render, staticRenderFns } from "./MainSliderModal.vue?vue&type=template&id=5b8ea08a&scoped=true&"
import script from "./MainSliderModal.vue?vue&type=script&lang=js&"
export * from "./MainSliderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8ea08a",
  null
  
)

export default component.exports